import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getConfigurationComparisonVendors } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithAvailability } from '@utils/formatter';
import { checkGroupPanelAccess } from '@utils/permissions';

import { TCMOptions } from '@interfaces/cmModule/cmModule';
import { TNameTitle } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { cmModuleGroupAccess } from '@constants/menuGroupAccess';
import { CC_VENDORS } from '@constants/queryKeys';

export const useQueryConfigurationComparisonVendors = () => {
	const { accessPermission } = useAppSelector(auth);

	const isVisibleCmModule = checkGroupPanelAccess(accessPermission, cmModuleGroupAccess);

	const {
		data: vendorsOptions,
		isFetching: isFetchingVendorsOptions,
		isInitialLoading,
	} = useQuery<TCMOptions<TNameTitle>[]>({
		queryKey: [CC_VENDORS],
		enabled: [isVisibleCmModule],
		queryFn: extractQueryParams(getConfigurationComparisonVendors),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		vendorsOptions: optionsFormattedWithAvailability(vendorsOptions || []),
		allVendorsOptions: vendorsOptions || [],
		isLoadingVendorsOptions: isFetchingVendorsOptions || isInitialLoading,
	};
};
